var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter__checkbox"},[_c('form-checkbox',{attrs:{"label":_vm.$t('lms.mediaLibrary.componentLibrary.selectMultimedia'),"name":'filter-checkbox'},model:{value:(_vm.checkboxValue),callback:function ($$v) {_vm.checkboxValue=$$v},expression:"checkboxValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }